const Loading = ({waiting}) => {
    return (
        waiting ?
        <div className="loading">لطفا منتظر بمانید...</div>:
        ""
    );
}

export default Loading;